import React from "react";
import { ButtonRoles, PrimaryButton, ButtonSizes } from "../../../..";
import { FlexCenter } from "../styles";
export var ModalButton = function (_a) {
    var onClick = _a.onClick, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, children = _a.children, fullWidth = _a.fullWidth;
    return (React.createElement(FlexCenter, null,
        React.createElement(PrimaryButton, { size: ButtonSizes.large, onClick: onClick, "aria-label": ButtonRoles.primary, isLoading: isLoading, fullWidth: fullWidth }, children)));
};
